import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  Typography
} from '@mui/material';
import {
  DataGridPro,
  GridToolbarContainer,
  useGridApiContext
} from '@mui/x-data-grid-pro';
import { SEP_PLAN_TAB_LABELS } from '../../../shared/AppConstants';
import { getColumns } from './sepSpendColumns';
import { sepSpendGridStyle, SpendTableRow } from '../../../shared/spendUtils';

type SpendTableProps = {
  rows: SpendTableRow[];
  spendTypes: string[];
};

function CustomToolbar() {
  const apiRef = useGridApiContext();
  return (
    <GridToolbarContainer>
      <Button
        variant={'tertiary'}
        startIcon={<fuel-icon name={'download'} />}
        onClick={() =>
          apiRef.current.exportDataAsCsv({
            fileName: 'SEP_Aggregated_PDP_Spend'
          })
        }
      >
        {'Export'}
      </Button>
    </GridToolbarContainer>
  );
}

export const SepSpendTable = ({ rows, spendTypes }: SpendTableProps) => {
  return (
    <Accordion style={{ marginTop: '1rem', border: 0 }}>
      <AccordionSummary>
        <Typography variant={'h2'}>
          {SEP_PLAN_TAB_LABELS.SEP_SPEND_TABLE_TITLE}
        </Typography>
      </AccordionSummary>
      <AccordionDetails
        sx={(theme) => ({ px: theme.fuel6Tokens.JddcSpacingLarge })}
      >
        <DataGridPro
          autoHeight={true}
          hideFooter={true}
          showToolbar
          density="compact"
          getRowHeight={() => 'auto'}
          columns={getColumns(spendTypes)}
          rows={rows}
          sx={(theme) => ({
            ...sepSpendGridStyle(theme),
            width: '100%',
            '& .MuiDataGrid-columnSeparator': {
              display: 'none'
            }
          })}
          slots={{
            toolbar: CustomToolbar
          }}
        />
      </AccordionDetails>
    </Accordion>
  );
};
